/* eslint-disable */
/// This file is auto generated - do not edit manually
export const FromSupplier = 'Website.Checkout.SummaryBox.Delivery.FromSupplier';
